var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"z-depth-2"},[_c('div',{staticStyle:{"padding":"10px"}},[_c('h5',{staticClass:"center"},[_vm._v("\r\n            "+_vm._s(_vm.$t('uploadFellowsExcel.title'))+"\r\n        ")]),_vm._v(" "),_c('file-upload',{attrs:{"accept":_vm.accept,"headers":_vm.headers,"url":_vm.url},on:{"change":_vm.onFileChange,"error":_vm.onError,"success":_vm.onSuccess}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10fd3f22","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/custom-file-upload/custom-file-upload.html
// module id = null
// module chunks = 